import React from "react"
import type { ChildComponentProps } from "google-map-react"

import { formatPrice } from "~utils/helpers"
import type {
    PublicSearchListingFieldsFragment,
    SearchListingFieldsFragment,
} from "~graphql/generated/graphql"
import ListingImageCard from "~components/shared/todo-lib-react-components/image-card/listing-image-card"
import MapMarker from "~components/shared/todo-lib-react-components/map-marker"

interface Props extends ChildComponentProps {
    readonly listing:
        | PublicSearchListingFieldsFragment
        | SearchListingFieldsFragment
}

export default function ListingsMapMarker({ listing, ...rest }: Props) {
    const lowestPrice = formatPrice(listing.lowest_pricing_package?.price)

    return (
        <MapMarker label={lowestPrice} {...rest}>
            <ListingImageCard listing={listing} />
        </MapMarker>
    )
}
